<template>
    <yams-template>
        <template #header>
            <div class="mr-5">
                <h4 class="text-primary font-weight-bold">Demandes ({{ lines }})</h4>
            </div>
            <div class="mr-4">
                <NavOperations></NavOperations>
            </div>
            <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
                <button type="button" class="btn " @click.prevent="changeAffichage('table')"
                    :class="{ 'active': affichage === 'table' }">
                    <i class="fa-solid fa-bars"></i>
                </button>
                <button type="button" class="btn " @click.prevent="changeAffichage('card')"
                    :class="{ 'active': affichage === 'card' }">
                    <i class="fa-solid fa-border-all"></i>
                </button>
            </div>
            <div class="px-1">
                <button type="button" class="btn-yams btn-active" @click="openCreateModal()">
                    Ajouter une demande <i class="fa-solid fa-plus"></i>
                </button>
            </div>
        </template>
        <template #content>
            <div class="card mb-3">
                <div class="card-body p-2">
                    <FilterCustom 
                        :baseUrl="'/api/demandes'" 
                        :hasDateFilter="true"
                        :existingSelectors="['client']"
                        :selectOptions="[]"
                        @filter-applied="onFilterApplied"
                        @filter-reset="onFilterReset"
                        @get-existing-selectors="getExistingSelectorsParams"
                        @reset-existing-selectors="resetExistingSelectors">
                        
                        <template #existing-selectors>
                            <div class="filter-select-wrapper">
                                <label>Client</label>
                                <SelectClient :creation="false"
                                    :key="'client-' + componentKey"
                                    :line="selectedClient"
                                    @set-selected="onClientSelected" />
                            </div>
                        </template>
                    </FilterCustom>
                </div>
            </div>

            <div class="card mb-5">
        <div class="card-body p-1">
            <DataTableBackend :key="key" :url="currentUrl" :columns="columns"
                :table="table" :view-mode="affichage" @row-click="openShowModal"
                @set-selected-rows="getSelection" v-on:set-total-records="updateLines">
                <template #course_details=slotProps>
                    <span class="bg-secondary p-1 rounded text-white text-center">{{ slotProps.data.course_details }}</span>
                </template>
                <template #statut=slotProps>
                    <span class="p-2 rounded-pill badge" :class="{ 
                    'badge-secondary': slotProps.data.statut === 'Recherche en cours',
                    'badge-success': slotProps.data.statut === 'Accepté'
                }">
                    {{ slotProps.data.statut }}
                </span>
                </template>
            </DataTableBackend>
        </div></div>
        </template>
    </yams-template>
</template>

<script>
import $ from "jquery"
import { defineComponent, defineAsyncComponent } from 'vue';
import NavOperations from '@/views/operations/NavOperations.vue';
import FilterCustom from '@/components/FilterCustom.vue';
import SelectClient from '@/views/operations/clients/SelectClient.vue';

const FormReservation = defineAsyncComponent(() => import('@/views/operations/reservations/FormReservation.vue'));
const ShowReservation = defineAsyncComponent(() => import('@/views/operations/reservations/ShowReservation.vue'));

export default defineComponent({
    name: 'IndexCourse',
    components: { NavOperations, FilterCustom, SelectClient },
    data() {
        return {
            lines: 0,
            key: 1,
            baseURL: this.$store.getters.apiUrl,
            currentUrl: this.$store.getters.apiUrl + '/api/demandes',
            table: 'demandes',
            affichage: "table",
            selection: [],
            componentKey: 1,
            selectedClient: null,
            columns: [
                {
                    key: 'client_nom_complet',
                    label: 'Client',
                    exportable: true,
                    sortable :true
                },
                {
                    key: 'type_course',
                    label: 'Type',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'course_details',
                    class: 'bg-secondary p-1 rounded text-white text-center',
                    label: 'Trajet',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'statut',
                    label: 'Statut',
                }
            ]
        };
    },
    methods: {
        onClientSelected(client) {
            this.selectedClient = client;
        },
        
        onFilterApplied(filteredUrl) {
            this.currentUrl = filteredUrl;
            this.key++;
        },
        
        onFilterReset(baseUrl) {
            this.currentUrl = baseUrl;
            this.selectedClient = null;
            this.key++;
        },
        
        getExistingSelectorsParams(callback) {
            const existingParams = {};
            if (this.selectedClient && this.selectedClient.id) {
                existingParams.client = this.selectedClient.id;
            }
            callback(existingParams);
        },
        
        resetExistingSelectors() {
            this.selectedClient = null;
            this.componentKey++;
        },
        changeAffichage(type) {
            this.affichage = type;
            this.key++
        },
        getSelection(selection) {
            this.selection = selection
        },
        openShowModal(objData) {
            this.$dialog.open(ShowReservation, {
                props: {
                    header: "Reservation de course ID" + objData.id,
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
                data: objData
            });
        },
        openCreateModal() {
            this.$dialog.open(FormReservation, {
                props: {
                    header: "Nouvelle demande de course",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                }
            });
        },
        updateLines(nb_lines) {
            this.lines = nb_lines
        }
    }
});
</script>

<style scoped>
.filter-select-wrapper {
    min-width: 200px;
    margin-bottom: 10px;
}

:deep(.card-body) {
    flex: none !important;
}
</style>